import { Component, HostListener, OnInit, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { AuthService } from '../../services/auth.service';
import { KeycloakService } from 'keycloak-angular';
import { NotificationService } from '../../services/notifications.service';
import { ICompany } from '../../model/company.model';
import { BaseService } from '../../services/base.service';
import { ProfileService } from '../../services/profile.service';
import { environment } from '../../../environments/environment';
import { NAME_PROJECT } from '../../enum/constants';

@Component({
  templateUrl: './companies.component.html',
  styleUrls: ['./companies.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class CompaniesComponent implements OnInit, OnDestroy {
  private readonly destroy$ = new Subject<null>();
  protected readonly environment = environment;

  slideConfig = {
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
  };

  images = [
    {
      img: '/assets/images/special/slide1.jpg',
      heading: 'companies_info.you_are_just_a_moment_away_from',
      description: 'companies_info.slide1',
    },
    {
      img: '/assets/images/special/slide2.jpg',
      heading: 'companies_info.you_are_just_a_step_away_from',
      description: 'companies_info.slide2',
    },
    {
      img: '/assets/images/special/slide3.jpg',
      heading: 'companies_info.you_are_just_a_few_minutes_from',
      description: 'companies_info.slide3',
    },
    {
      img: '/assets/images/special/slide4.jpg',
      heading: 'companies_info.you_are_just_a_step_away_from',
      description: 'companies_info.slide4',
    },
    {
      img: '/assets/images/special/slide5.jpg',
      heading: 'companies_info.you_are_just_a_moment_away_from',
      description: 'companies_info.slide5',
    },
  ];

  constructor(
    private readonly router: Router,
    public readonly authService: AuthService,
    private readonly keycloakService: KeycloakService,
    private readonly profileService: ProfileService,
    private readonly notificationService: NotificationService,
    public readonly baseService: BaseService,
  ) {}

  public companies: ICompany[] = [];
  public subdomain!: string;
  public isLoader: boolean = false;

  ngOnInit() {
    this.profileService.checkPhone();
    this.initCompanies();
  }

  ngOnDestroy(): void {
    this.destroy$.next(null);
    this.destroy$.complete();
  }

  private initCompanies() {
    this.isLoader = true;
    this.authService.getCompanies().subscribe({
      next: (res) => {
        this.companies = res.data;
        this.isLoader = false;
      },
      error: () => {
        this.isLoader = false;
      },
    });
  }

  createCompany() {
    this.isLoader = true;
    this.authService.createCompany().subscribe({
      next: () => {
        this.initCompanies();
      },
      error: (res) => {
        this.isLoader = false;
        console.log(res.error);
        (res.error?.errors || []).forEach((err: any) => {
          this.notificationService.showError('', err.message);
        });
      },
    });
  }

  onSelectCompany(subdomain: string) {
    this.subdomain = subdomain;

    const token = this.keycloakService.getKeycloakInstance().token;
    const refreshToken = this.keycloakService.getKeycloakInstance().refreshToken;
    const protocol = window.location.protocol;
    let host;

    if (window.location.host.includes('auth')) {
      host = window.location.host.replace('auth', this.subdomain);
    } else if (environment.default_schema) {
      host = window.location.host;
    } else {
      switch (environment.env) {
        case 'local':
          host = window.location.host.replace('localhost', `${this.subdomain}.localhost`);
          break;
        case 'dev':
          host = window.location.host.replace('dev', `${this.subdomain}.dev`);
          break;
        case 'prod':
          host = window.location.host.replace('jecrm', `${this.subdomain}.jecrm`);
          break;
      }
    }

    window.location.href = `${protocol}//${host}/sso/${token}/${refreshToken}`;
  }

  logout() {
    this.authService.logout();
  }
}
